import { render, staticRenderFns } from "./CatalogueFilters.vue?vue&type=template&id=4887b275&scoped=true"
import script from "./CatalogueFilters.vue?vue&type=script&lang=js"
export * from "./CatalogueFilters.vue?vue&type=script&lang=js"
import style0 from "./CatalogueFilters.vue?vue&type=style&index=0&id=4887b275&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4887b275",
  null
  
)

export default component.exports